import { enqueueSnackbar } from 'notistack';
import { debounce } from 'lodash';
import PropTypes from 'prop-types';
import { useCallback, useMemo, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useSelector } from '../../redux/store';
import { updateUserSettings } from '../../redux/slices/user';
import { GetGridKeys } from './dataGridHelper';

DataGridPersistSettings.propTypes = {
  gridId: PropTypes.string,
  columns: PropTypes.array
};

export default function DataGridPersistSettings({ gridId, columns }) {

  const { gridKey } = GetGridKeys(gridId);
  const { user: { settings } } = useSelector((state) => state.user);
  const gridPersists = settings?.find((setting) => setting?.areaId === 'GridPersists')?.show ?? true;
  const gridSettings = settings?.find((setting) => setting?.areaId === gridKey);

  const gridSettingsParsed = useMemo(() => {
    if (!gridSettings?.value) return null;
    try {
      return JSON.parse(gridSettings?.value);
    }
    catch (error) {
      enqueueSnackbar('Failed to load grid settings', { variant: 'error' });
      return null;
    }
  }, [gridSettings]);

  const dispatch = useDispatch();

  const updateGridSettings = useCallback(debounce((newGridState = null) => {
    const allGridSettings = { gridState: newGridState || gridSettingsParsed?.gridState || {} };
    dispatch(updateUserSettings([{
      areaId: gridKey,
      field: '',
      show: false,
      style: '',
      value: JSON.stringify(allGridSettings),
    }]));
  }, 1000), []);

  useEffect(() => {
    if (gridKey && columns?.length) {
      const initGridSettings = async () => {
        const dataGridStateStorage = gridKey;
        const gridStateFromStorage = localStorage.getItem(dataGridStateStorage);
        if (!gridSettings && gridStateFromStorage) {
          await updateGridSettings(JSON.parse(gridStateFromStorage));
          localStorage.removeItem(dataGridStateStorage);
        }
      };
      initGridSettings();
    }
  }, [gridKey, columns]);  

  return { gridPersists, gridSettings: gridSettingsParsed, updateGridSettings };
}